import script from "./Cartelera.vue?vue&type=script&setup=true&lang=js"
export * from "./Cartelera.vue?vue&type=script&setup=true&lang=js"

import "./Cartelera.vue?vue&type=style&index=0&id=154fc49c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154fc49c"]])

export default __exports__